import { render } from "./licence_list.vue?vue&type=template&id=7661979d&scoped=true&ts=true"
import script from "./licence_list.vue?vue&type=script&lang=ts"
export * from "./licence_list.vue?vue&type=script&lang=ts"

import "./licence_list.vue?vue&type=style&index=0&id=7661979d&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7661979d"]])

export default __exports__